var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disponivel)?_c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.adicionarProduto($event)}}},[_vm._v("Adicionar")]):_c('button',{staticClass:"esgotado"},[_vm._v("Esgotado")])}
var staticRenderFns = []

export { render, staticRenderFns }